import { Row, Col, Typography, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { FC, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Container, Content, OrderedList, StyledParagraph } from './styled';

const { Title } = Typography;

const PrivacyPolicy: FC = () => {
  // translations
  const { t, i18n } = useTranslation();
  // navigation
  const [search] = useSearchParams();

  useEffect(() => {
    const lang = search.get('lang');

    if (lang && ['en', 'de'].includes(lang)) {
      i18n.changeLanguage(lang);
    }
  }, [i18n, search]);

  return (
    <Content>
      <Container>
        <Title level={1} style={{ marginBottom: 24 }}>
          {t('privacy.title')}
        </Title>
        <Row gutter={32} justify="center" style={{ paddingBottom: 10 }}>
          <Col xs={{ span: 24 }} lg={{ span: 18 }}>
            <Card
              bordered={false}
              style={{ borderRadius: 8 }}
              bodyStyle={{ padding: 24 }}
            >
              <Title level={3} style={{ marginBottom: 24 }}>
                {t('privacy.description')}
              </Title>
              <StyledParagraph>
                {t('privacy.desc_item_1')} <br />
                {t('privacy.desc_item_2')}
                <br />
                {t('privacy.desc_item_3')}
                <br />
                {t('privacy.desc_item_4')}
                <br />
                {t('privacy.desc_item_5')}
              </StyledParagraph>
              <StyledParagraph>
                <span
                  dangerouslySetInnerHTML={{ __html: t('privacy.info') }}
                ></span>
              </StyledParagraph>

              <Title level={3} style={{ marginBottom: 24 }}>
                {t('privacy.block1_title')}
              </Title>
              <StyledParagraph>{t('privacy.block1_start')}</StyledParagraph>
              <StyledParagraph>
                <OrderedList>
                  <li>{t('privacy.item1')}</li>
                  <li>{t('privacy.item2')}</li>
                  <li>{t('privacy.item3')}</li>
                  <li>{t('privacy.item4')}</li>
                  <li>{t('privacy.item5')}</li>
                  <li>{t('privacy.item6')}</li>
                </OrderedList>
              </StyledParagraph>
              <StyledParagraph>{t('privacy.block1_end')}</StyledParagraph>
              <Title level={3} style={{ marginBottom: 24 }}>
                {t('privacy.block2_title')}
              </Title>
              <StyledParagraph>{t('privacy.block2')}</StyledParagraph>
              <Title level={3} style={{ marginBottom: 24 }}>
                {t('privacy.block3_title')}
              </Title>
              <StyledParagraph>
                <span
                  dangerouslySetInnerHTML={{ __html: t('privacy.block3') }}
                ></span>
              </StyledParagraph>
              <Title level={3} style={{ marginBottom: 24 }}>
                {t('privacy.block4_title')}
              </Title>
              <StyledParagraph>
                <span
                  dangerouslySetInnerHTML={{ __html: t('privacy.block4') }}
                ></span>
              </StyledParagraph>
              <Title level={3} style={{ marginBottom: 24 }}>
                {t('privacy.block5_title')}
              </Title>
              <StyledParagraph>
                <span
                  dangerouslySetInnerHTML={{ __html: t('privacy.block5') }}
                ></span>
              </StyledParagraph>
              <Title level={3} style={{ marginBottom: 24 }}>
                {t('privacy.block6_title')}
              </Title>
              <StyledParagraph>
                <span
                  dangerouslySetInnerHTML={{ __html: t('privacy.block6') }}
                ></span>
              </StyledParagraph>
              <Title level={3} style={{ marginBottom: 24 }}>
                {t('privacy.block7_title')}
              </Title>
              <StyledParagraph>{t('privacy.block7_start')}</StyledParagraph>
              <StyledParagraph>
                <OrderedList>
                  <li>{t('privacy.block7_item1')}</li>
                  <li>{t('privacy.block7_item2')}</li>
                  <li>{t('privacy.block7_item3')}</li>
                  <li>{t('privacy.block7_item4')}</li>
                  <li>{t('privacy.block7_item5')}</li>
                  <li>{t('privacy.block7_item6')}</li>
                  <li>{t('privacy.block7_item7')}</li>
                  <li>{t('privacy.block7_item8')}</li>
                </OrderedList>
              </StyledParagraph>
              <StyledParagraph>
                <span
                  dangerouslySetInnerHTML={{ __html: t('privacy.block7_end') }}
                ></span>
              </StyledParagraph>
              <Title level={3} style={{ marginBottom: 24 }}>
                {t('privacy.block8_title')}
              </Title>
              <StyledParagraph>
                <span
                  dangerouslySetInnerHTML={{ __html: t('privacy.block8') }}
                ></span>
              </StyledParagraph>
              <Title level={3} style={{ marginBottom: 24 }}>
                {t('privacy.block9_title')}
              </Title>
              <StyledParagraph>
                <span
                  dangerouslySetInnerHTML={{ __html: t('privacy.block9') }}
                ></span>
              </StyledParagraph>
              <StyledParagraph>
                <div id="cookiefirst-policy-page" />
                <div>
                  This cookie policy has been created and updated by{' '}
                  <a href="https://cookiefirst.com/cookie-consent/">
                    the Cookie Consent Tool
                  </a>
                  .
                </div>
              </StyledParagraph>
            </Card>
          </Col>
        </Row>
      </Container>
    </Content>
  );
};

export default PrivacyPolicy;
